import Head from "next/head";
import { useTranslation } from "@/components/useTranslation";

export default function Impressum() {

    const t = useTranslation();

    return (
        <>
            <Head>
                <title> Resenas123 | {t.impressum} </title>
            </Head>
            <div className='max-w-6xl py-32 mx-auto md:px-8 sub-page-content'>
                <div className="relative w-full ">
                    <div className="relative">
                        <div className="flex items-start justify-between p-4 border-b rounded-t">
                            <h1 className="text-3xl font-semibold text-gray-900"> {t.impressum} </h1>
                        </div>
                        <div className="p-6 space-y-6">
                            <div className="modal-inner">
                                <div className="py-3">
                                    <h6 className="py-3">Resenas123.es</h6>
                                    <p className="m-0">78 Avenue des Champs-Élysées France 1, 75008 <br /> Paris, France</p>
                                </div>
                                <div className="py-3">
                                    <h6>Kontakt:</h6>
                                    <p className="m-0">E-Mail: <a href="mailto:info@resenas123.es" style={{ "fontSize": "0.8rem", "letterSpacing": "1.2", "color": "#444444" }}>info@resenas123.es</a></p>
                                    <p className="m-0">Telefon: <a href="tel:0353791047" style={{ "fontSize": "0.8rem", "letterSpacing": "1.2", "color": "#444444" }}>0353791047</a></p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step1_title}</h6>
                                    <p>{t.impressum_step1_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step2_title}</h6>
                                    <p>{t.impressum_step2_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step3_title}</h6>
                                    <p>{t.impressum_step3_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step4_title}</h6>
                                    <p>{t.impressum_step4_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step5_title}</h6>
                                    <p>{t.impressum_step5_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step6_title}</h6>
                                    <p>{t.impressum_step6_description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}